import { readFromLocalStorage, writeToLocalStorage } from "@bokio/hooks/useLocalStorage/useLocalStorage";

import { toPrefixedClassName } from "./designSystemPreview.helper";

import type { DesignSystemPreview } from "./designSystemPreview.helper";

const storageKey = "useDesignSystemPreview";

const enabledDesignSystemPreviews: Set<DesignSystemPreview> = new Set(
	readFromLocalStorage<DesignSystemPreview[]>(storageKey) ?? [],
);

enabledDesignSystemPreviews.forEach(className => {
	document.documentElement.classList.add(toPrefixedClassName(className));
});

export const setDesignSystemPreview = (newEnabled: DesignSystemPreview[]) =>
	writeToLocalStorage(storageKey, newEnabled);

export const isDesignSystemPreviewEnabled = (previewType: DesignSystemPreview) =>
	enabledDesignSystemPreviews.has(previewType);
